import { a as c } from "./chunk-BaseElement-CJM6sCUz.js";
import { d } from "./chunk-debounce-Bk6yKvzA.js";
import { W as h } from "./chunk-WithShopifyCart-BrHwaVIT.js";
import { t as f } from "./chunk-custom-element-CN0MC8o7.js";
import "./chunk-lit-element-D3OkYgeM.js";
var u = Object.getOwnPropertyDescriptor, p = (t, e, r, l) => {
  for (var i = l > 1 ? void 0 : l ? u(e, r) : e, s = t.length - 1, o; s >= 0; s--)
    (o = t[s]) && (i = o(i) || i);
  return i;
};
const a = "_filter_collapsed";
let n = class extends h(
  c
) {
  constructor() {
    super(), this.handleToggle = this.handleToggle.bind(this), this._debouncedScrollHandler = d(this.handleScroll.bind(this), 100), this.formContainer = this.querySelector("facet-filters-form"), this.facetList = this.querySelector("[data-filter-facet-list]");
  }
  connectedCallback() {
    super.connectedCallback(), this._initListeners();
  }
  _initListeners() {
    var t;
    document.addEventListener("facet-drawer:toggle", this.handleToggle), (t = this.facetList) == null || t.addEventListener("scroll", this._debouncedScrollHandler);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), document.removeEventListener("facet-drawer:toggle", this.handleToggle), (t = this.facetList) == null || t.removeEventListener("scroll", this._debouncedScrollHandler);
  }
  open() {
    this.setAttribute("aria-expanded", "true"), this.updateCartNoteAndAttributes(
      {
        attributes: {
          [a]: "1"
        }
      },
      { sections: !1 }
    );
  }
  close() {
    this.setAttribute("aria-expanded", "false"), this.updateCartNoteAndAttributes(
      {
        attributes: {
          [a]: "0"
        }
      },
      { sections: !1 }
    );
  }
  handleToggle() {
    this.getAttribute("aria-expanded") !== "true" ? this.open() : this.close();
  }
  handleScroll() {
    var e, r;
    if (!this.facetList) return;
    this.facetList.scrollHeight - (this.facetList.scrollTop + this.facetList.clientHeight) <= 25 ? (e = this.formContainer) == null || e.setAttribute("data-end-of-scroll", "") : (r = this.formContainer) == null || r.removeAttribute("data-end-of-scroll");
  }
};
n = p([
  f("filters-drawer")
], n);
export {
  n as FiltersDrawer
};
